import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Select from "react-select";

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Controller, useForm } from "react-hook-form";
import { post } from "helpers/api_helper";
import { NOZZLE_CREATE } from "helpers/url_helper";
import { Link, useNavigate } from "react-router-dom";


const CreateNozzle = () => {
  const Navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);  // Modal state
  const [fillerOptions, setFillerOptions] = useState([]);
  
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const handleDelete = (item) => {
    setModalOpen(true);  // Open the modal
  };

  useEffect(() => {
    window.google && window.google.load("elements", "1", {
      packages: "transliteration",
      callback: onLoadTransliteration,
    });

    function onLoadTransliteration() {
      const control = new window.google.elements.transliteration.TransliterationControl({
        sourceLanguage: window.google.elements.transliteration.LanguageCode.ENGLISH,
        destinationLanguage: [window.google.elements.transliteration.LanguageCode.GUJARATI],
        transliterationEnabled: true,
      });

      // Add IDs of the input fields to transliterate
      control.makeTransliteratable(["name", "address", "notes"]);
    }
  }, []);
  const {
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    control,
  } = useForm({
    defaultValues: {
      nozzel_no: "",
      vehicle_no: "",
      total_capacity: "",
      remaining_capacity: "",
      status: 0,
      current_assigned_filler_ul_id: "",
      notes: "",
      ul_id: "",
    },
  });

  const breadcrumbItems = [
    { title: "valfuel", link: "/" },
    { title: "Create Order", link: "#" },
  ];

const onSubmit = async (value) => {
  const payload = {
    ...value,
  };
  try {
    const response = await post(NOZZLE_CREATE, payload);

    toastr.success("Order placed successfully!");
    Navigate("/nozzles");  // ✅ Only navigates if API succeeds
  } catch (error) {
    const status = error?.response?.status;
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to place order.";
    toastr.error(`${status ? status + " - " : ""}${message}`);
  } finally {
    reset(); // optional: you might not want to reset on failure
  }
};



  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Create Order" breadcrumbItems={breadcrumbItems} />
        </Container>
        <Row>
          <Col xl="12">
            <Card>
              <CardBody>
                <Form
                  className="needs-validation"
                  method="post"
                  id="customerCreateForm"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <Row>
                    <Col md="6" xl="3">
                      <div className="mb-3">
                        <Label>Nozzle No <span className="text-danger">*</span></Label>
                        <Controller
                          name="nozzel_no"
                          control={control}
                          rules={{ required: "Nozzle number is required" }}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="text"
                              placeholder="Enter Nozzle No"
                              className={`form-control ${errors.nozzel_no ? "is-invalid" : ""}`}
                            />
                          )}
                        />
                        {errors.nozzel_no && <div className="text-danger">{errors.nozzel_no.message}</div>}
                      </div>
                    </Col>
                    <Col md="6" xl="3">
                      <div className="mb-3 position-relative">
                        <Label className="form-label" htmlFor="vehicle_no">
                          Vehicle Number <span className="text-danger">*</span>
                        </Label>

                        <Controller
                            name="vehicle_no"
                            control={control}
                            rules={{
                              required: "Vehicle Number is required",
                              pattern: {
                                value: /^[A-Z]{2}-\d{1,2}-[A-Z]{1,3}-\d{4}$/,
                                message: "Format must be like GJ-19-Z-1587",
                              },
                            }}
                            render={({ field }) => (
                              <Input
                                {...field}
                                maxLength={15}
                                onChange={(e) => {
                                  let raw = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                
                                  // Extract parts strictly based on format
                                  const state = raw.slice(0, 2);
                                  const district = raw.slice(2, 4); // can be 1 or 2 digits
                                  let remaining = raw.slice(4);
                
                                  let series = '';
                                  let number = '';
                
                                  // Extract series (letters) and number (digits) from the rest
                                  const match = remaining.match(/^([A-Z]{1,3})(\d{1,4})?$/);
                                  if (match) {
                                    series = match[1] || '';
                                    number = match[2] || '';
                                  }
                
                                  // Combine into formatted string
                                  let formatted = [state, district, series, number]
                                    .filter(Boolean)
                                    .join('-');
                
                                  field.onChange(formatted);
                                }}
                                className={`form-control ${errors.vehicle_no ? 'is-invalid' : ''}`}
                                placeholder="e.g. GJ-00-AA-0000"
                              />
                            )}
                          /> 
                        {errors.vehicle_no?.message && (
                          <div className="text-danger">
                            {errors.vehicle_no.message}
                          </div>
                        )}

                      </div>
                    </Col>

                    <Col md="6" xl="3">
                      <div className="mb-3">
                        <Label>Total Capacity (Ltr) <span className="text-danger">*</span></Label>
                        <Controller
                          name="total_capacity"
                          control={control}
                          rules={{ required: "Total capacity is required" }}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="text"
                              inputMode="numeric"
                              maxLength={5}
                              pattern="[0-9]*"
                              onChange={(e) => field.onChange(e.target.value.replace(/\D/g, '' )) }
                              placeholder="Enter Total Capacity"
                              className={`form-control ${errors.total_capacity ? "is-invalid" : ""}`}
                            />
                          )}
                        />
                        {errors.total_capacity && <div className="text-danger">{errors.total_capacity.message}</div>}
                      </div>
                    </Col>

                    <Col md="6" xl="3">
                      <div className="mb-3">
                        <Label>Remaining Capacity (Ltr) <span className="text-danger">*</span></Label>
                        <Controller
                          name="remaining_capacity"
                          control={control}
                          rules={{ required: "Remaining capacity is required" }}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="text"
                              inputMode="numeric"
                              maxLength={5}
                              pattern="[0-9]*"
                              onChange={(e) => field.onChange(e.target.value.replace(/\D/g, '' )) }
                              placeholder="Enter Remaining Capacity"
                              className={`form-control ${errors.remaining_capacity ? "is-invalid" : ""}`}
                            />
                          )}
                        />
                        {errors.remaining_capacity && <div className="text-danger">{errors.remaining_capacity.message}</div>}
                      </div>
                    </Col>
                    {/* <Col md="6" xl="3">
                      <div className="mb-3">
                        <Label>Assigned Filler ID</Label>
                        <Controller
                          name="current_assigned_filler_ul_id"
                          control={control}
                          //rules={{ required: "Filler UL ID is required" }}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="text"
                              placeholder="Enter Filler UL ID"
                              className={`form-control ${errors.current_assigned_filler_ul_id ? "is-invalid" : ""}`}
                            />
                          )}
                        />
                        {errors.current_assigned_filler_ul_id && <div className="text-danger">{errors.current_assigned_filler_ul_id.message}</div>}  
                      </div>
                    </Col> */}

                    <Col md="12">
                      <div className="mb-3">
                        <Label>Remarks</Label>
                        <Controller
                          name="notes"
                          control={control}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="textarea"
                              placeholder="Enter Remarks"
                              rows={3}
                              className="form-control"
                            />
                          )}
                        />
                      </div>
                    </Col>
                  </Row>

                  <div className="text-end">
                    <Button type="submit" color="primary" disabled={isSubmitting}>
                        {isSubmitting ? "Submitting..." : "Submit"}
                      </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

    </React.Fragment>
  );
};

export default CreateNozzle;
